import { TransactionType } from "@syla/shared/types/models/TransactionBase";
import { StandardSelectOption } from "../../components/selector/parts/SelectOption";
import AddLiquidity from "../../images/icons/Transactions/Add Liquidity.svg";
import Group from "../../images/icons/Transactions/Group.svg";
import Rebase from "../../images/icons/Transactions/Rebase.svg";
import Receive from "../../images/icons/Transactions/Receive.svg";
import RemoveLiquidity from "../../images/icons/Transactions/Remove Liquidity.svg";
import Send from "../../images/icons/Transactions/Send.svg";
import Trade from "../../images/icons/Transactions/Trade.svg";
import Transaction from "../../images/icons/Transactions/Transaction.svg";
import Mint from "../../images/icons/Transactions/transactionIncrease/mint.svg";
import Wrap from "../../images/icons/Transactions/Wrap.svg";

export type TransactionTypeOption = StandardSelectOption<TransactionType> & {
  data: {
    icon: string;
  };
};

export const transactionTypeOptions: Record<
  TransactionType,
  TransactionTypeOption
> = {
  [TransactionType.Trade]: {
    value: TransactionType.Trade,
    data: {
      label: TransactionType.Trade,
      icon: Trade,
      description: "Exchange any asset for any another asset",
    },
  },
  [TransactionType.Rebase]: {
    value: TransactionType.Rebase,
    data: {
      label: TransactionType.Rebase,
      icon: Rebase,
      description: "Change the ticker name or quantity of an asset",
    },
  },
  Mint: {
    value: TransactionType.Mint,
    data: {
      label: TransactionType.Mint,
      icon: Mint,
      description: "Mint a new asset",
    },
  },
  [TransactionType.Wrap]: {
    value: TransactionType.Wrap,
    data: {
      label: TransactionType.Wrap,
      icon: Wrap,
      description: "Transfer asset between blockchains",
    },
  },
  [TransactionType.Receive]: {
    value: TransactionType.Receive,
    data: {
      label: TransactionType.Receive,
      icon: Receive,
      description: "Receive an asset",
    },
  },
  [TransactionType.AddLiquidity]: {
    value: TransactionType.AddLiquidity,
    data: {
      label: TransactionType.AddLiquidity,
      icon: AddLiquidity,
      description: "Add to a liquidity pool",
    },
  },
  [TransactionType.Send]: {
    value: TransactionType.Send,
    data: {
      label: TransactionType.Send,
      icon: Send,
      description: "Send an asset",
    },
  },
  [TransactionType.RemoveLiquidity]: {
    value: TransactionType.RemoveLiquidity,
    data: {
      label: TransactionType.RemoveLiquidity,
      icon: RemoveLiquidity,
      description: "Withdraw from a liquidity pool",
    },
  },
  [TransactionType.Transaction]: {
    value: TransactionType.Transaction,
    data: {
      label: TransactionType.Transaction,
      icon: Transaction,
      description: "Any type of transaction",
    },
  },
};

export const getTransactionTypeOptions = Object.values(transactionTypeOptions);

export const getTransactionTypeIcon = (
  type: TransactionType | "group",
): string => {
  switch (type) {
    case "group":
      return Group;
    default:
      return transactionTypeOptions[type].data.icon;
  }
};
